import React, { useState } from "react";
import "./Solucoes.css";

function Solucoes() {
  const slides = [
    {
      titulo: "Empreendedores",
      texto:
        "Ter um site, estar no Google Meu Negócio e registrar a marca aumentam a visibilidade, credibilidade e proteção do negócio.",
    },
    {
      titulo: "Pequenas e médias empresas",
      texto:
        "Ganham mais visibilidade, credibilidade e facilidade para atrair clientes com um site profissional feito pela Loretech.ls.",
    },
    {
      titulo: "Startups",
      texto:
        "Fortalecem sua marca e atraem mais clientes combinando site profissional e Google Meu Negócio.",
    },
    {
      titulo: "Grandes empresas",
      texto:
        "Garantem presença digital forte, mais visibilidade e otimização completa com todos os serviços da Loretech.ls.",
    },
  ];

  const [atual, setAtual] = useState(0);
  const [clicado, setClicado] = useState(false);

  const anterior = () => {
    setAtual(atual === 0 ? slides.length - 1 : atual - 1);
    animarCard();
  };

  const proximo = () => {
    setAtual(atual === slides.length - 1 ? 0 : atual + 1);
    animarCard();
  };

  function animarCard() {
    setClicado(true);
    setTimeout(() => setClicado(false), 200);
  }

  return (
    <section className="solucoes-section" id="solucoes">
      <div className="solucoes-container">
        {/* REMOVIDO — NÃO MOSTRAR A IMAGEM */}
        {/* <div className="solucoes-left">
          <img src={imageLeft} alt="Soluções" />
        </div> */}

        <div className="solucoes">
          <h1 className="solucoes-title">
            Quem pode se beneficiar das nossas soluções?
          </h1>

          <div className={`solucoes-card ${clicado ? "card-click" : ""}`}>
            <h2>{slides[atual].titulo}</h2>
            <p>{slides[atual].texto}</p>

            <div className="solucoes-arrows">
              <button className="arrow" onClick={anterior}>
                ‹
              </button>
              <button className="arrow" onClick={proximo}>
                ›
              </button>
            </div>
          </div>

          <a
            href="https://wa.me/5511988833017"
            target="_blank"
            rel="noopener noreferrer"
            className="solucoes-button"
          >
            Fale com um especialista →
          </a>
        </div>
      </div>
    </section>
  );
}

export default Solucoes;
